export const getEncodedUrl = (path, data) => {
    const params = Object.keys(data)
        .map((key) => key && data[key] ? `${key}=${encodeURIComponent(data[key])}` : "")
        .filter(Boolean)
        .join("&");
    return `${path}?${params}`;
};
